import { useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "../../lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const DUREES = [["1m", "1 mois"], ["3m", "3 mois"], ["6m", "6 mois"], ["12m", "12 mois"], ["vie", "À vie"]];

export function SignDialog({ demo, onClose, onSaved }) {
  const [duration, setDuration] = useState("12m");
  const [busy, setBusy] = useState(false);
  if (!demo) return null;
  const sign = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/admin/demos/${demo.id}/signer`, { duration });
      onSaved(data); onClose();
      toast.success(`Contrat signé — licence ${data.license_key} activée${data.welcome_email_sent ? ", e-mail de bienvenue envoyé" : " (échec de l'e-mail de bienvenue)"}`);
    } catch (e) { toast.error(apiError(e, "Signature impossible")); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="sign-dialog">
        <DialogHeader><DialogTitle className="text-navy">Contrat signé — {demo.establishment}</DialogTitle></DialogHeader>
        <p className="text-sm text-slate-600">La licence VLS de l'offre <b>{demo.offre}</b> sera activée et l'e-mail de bienvenue envoyé à {demo.email}.</p>
        <p className="text-xs font-bold uppercase tracking-wider text-[#0369A1]">Durée de la licence</p>
        <div className="flex flex-wrap gap-2" data-testid="sign-durations">
          {DUREES.map(([v, l]) => (
            <button key={v} onClick={() => setDuration(v)} data-testid={`sign-duration-${v}`}
              className={`rounded-full px-4 py-1.5 text-sm font-semibold transition-colors ${duration === v ? "bg-[#0369A1] text-white" : "bg-[#E0F2FE] text-[#0369A1] hover:bg-[#BAE6FD]"}`}>{l}</button>
          ))}
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={onClose} data-testid="sign-cancel">Annuler</Button>
          <Button onClick={sign} disabled={busy} data-testid="sign-confirm" className="bg-[#0369A1] hover:bg-[#075985]">Valider la signature</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
